import {
  MultiSelectProps as MantineMultiSelectProps,
  MultiSelect as MantineMultiSelect,
} from '@mantine/core';

export type MultiSelectProps = MantineMultiSelectProps;

export const MultiSelect = MantineMultiSelect;

MultiSelect.displayName = 'MultiSelect';
